export const APPLICATION_SERVICE_DOMAIN = window.env.VUE_APP_APPLICATION_SERVICE_DOMAIN;

// resource paths
export const APPLICATION_RESOURCE_PATH = '/application';
export const MODULE_RESOURCE_PATH = '/module';
export const MODULE_SETTINGS_RESOURCE_PATH = '/settings';
export const MODULE_TRANSLATIONS_RESOURCE_PATH = '/translations';
